<div class="welcome-dialog">
  <div class="header">
    <div class="d-flex align-items-center justify-content-center">
      <img class="header__title-icon" src="/assets/img/INSIGHTS_icon_white_with_colour.svg" alt="insights-logo-bulb" />
      <div class="header__title">Optimize Insights</div>
    </div>
  </div>
  <div class="body">
    <div class="body__title">
      Welcome to Optimize Insights, below are a collection of dashboards from the Insights Library. Select one to add to your home screen.
    </div>
    <div class="body__tiles__wrapper">
      <app-spinner *ngIf="loadingDashboards"></app-spinner>
      <div *ngIf="!loadingDashboards" class="body__tiles">
        <div *ngIf="user.roles.isAdmin && !dashboards.length" class="tile">
          <div class="tile__header">
            <span>Admin Only Tile</span>
          </div>
          <div class="tile__preview">
            <div class="add-to-home-button-wrapper">
              <button trgButton color="blue" class="h-30 lh-30 text-center px-12" (click)="addToHome.emit(null)">
                <i class="fas fa-home i-14 mr-4 i-circle bgc-white c-blue"></i>
                <span class="ml-2">Hide Dialog</span>
              </button> 
            </div>
          </div>
          <div class="tile__footer">
            <div class="mt-15 mb-5 pb-5 border-b-solid-1 bc-orange">
              <div class="c-light-blue fs-10 mb-6">Name:</div>
              <div class="c-text-color-dark fs-14">n/a</div>
            </div>
            <div class="m-0 mt-8 c-text-color-dark fs-12 lh-18 desc">
              No Welcome Screen dashboards have been configured, or are available to this organisation.
            </div>
          </div>
        </div>

        <div *ngFor="let dashboard of dashboards"
          class="tile"
          [class.selected]="selectedDashboardId == dashboard.id"
          (click)="selectDashboard.emit(dashboard)"
          (dblclick)="addToHome.emit(dashboard)">
          <div class="tile__header">
            <div class="d-flex align-items-center">
              <ng-container *ngIf="dashboard.visuals">
                <span class="c-light-blue fs-10 bold mr-4">Visualizations:</span>
                <span class="c-text-color-dark fs-14">{{dashboard.visuals?.length}}</span>
              </ng-container>
            </div>
          </div>
          <div class="tile__preview">
            <app-dashboard-preview
              [dashboard]="dashboard" [displayNames]="false"
              iconSize="16" smallIconSize="16"
              padding="10px"
              [color]="(selectedDashboardId == dashboard.id) ? 'alt__selected' : 'alt'"></app-dashboard-preview>
            <div class="add-to-home-button-wrapper" [hidden]="selectedDashboardId != dashboard.id">
              <button trgButton color="blue" class="h-30 lh-30 text-center px-12" (click)="addToHome.emit(dashboard)">
                <i class="fas fa-home i-14 mr-4 i-circle bgc-white c-blue"></i>
                <span class="ml-2">Add to Home</span>
              </button> 
            </div>
          </div>
          <div class="tile__footer">
            <div class="mt-15 mb-5 pb-5 border-b-solid-1 bc-orange">
              <div class="c-light-blue fs-10 mb-6">Name:</div>
              <div class="c-text-color-dark fs-14">{{dashboard.name}}</div>
            </div>
            <div class="m-0 mt-8 c-text-color-dark fs-12 lh-18 desc" [title]="dashboard.description">
              {{dashboard.description}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
